<template>
	<article class="b_card">
		<div class="b_card__header">
			<div class="b_card__image">
				<img
					:src="cardData.img"
					:alt="cardData.title"
					:title="cardData.title"
					width="120"
					height="120"
				/>
			</div>
			<div class="b_card__body">
				<h3
					class="b_card__title"
					:title="cardData.title"
					v-html="cardData.title"
				></h3>
				<p class="b_card__subtitle" v-html="cardData.desc"></p>
				<a
					v-if="cardData.links.length === 1"
					:href="cardData.links[0].href"
					:title="cardData.links[0].text"
					class="b_card__question-button"
					target="_blank"
				>
					{{ cardData.links[0].text }}
				</a>
			</div>
		</div>
		<div class="b_card__content">
			<ul v-if="cardData.apiData" class="b_card__list">
				<li class="b_card__item">
					<div class="b_card__val">
						{{ cardData.apiData.maxRate * 100 + '%' }}
					</div>
					<div class="b_card__desc">
						максимальная ставка
						<span
							v-if="cardData.jsonData?.tooltip_max_rate"
							class="b_card__hint"
						>
							<svg
								@mousemove="setCoordsTooltip"
								class="b_card__hint-icon"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle cx="7.99961" cy="8" r="5.9" stroke="#999999" />
								<path
									d="M7.44761 9.20005C7.44761 9.05818 7.45508 8.92751 7.47001 8.80805C7.49241 8.68111 7.53348 8.55791 7.59321 8.43845C7.66041 8.31151 7.75001 8.18085 7.86201 8.04645C7.98148 7.91205 8.13828 7.76271 8.33241 7.59845C8.64601 7.32965 8.88494 7.08698 9.04921 6.87045C9.21348 6.65391 9.29561 6.42245 9.29561 6.17605C9.29561 5.81765 9.17614 5.52271 8.93721 5.29125C8.69828 5.05978 8.36974 4.94405 7.95161 4.94405C7.53348 4.94405 7.20494 5.05978 6.96601 5.29125C6.72708 5.52271 6.60761 5.81765 6.60761 6.17605H5.59961C5.59961 5.86991 5.65188 5.58991 5.75641 5.33605C5.86841 5.07471 6.02521 4.85071 6.22681 4.66405C6.43588 4.46991 6.68601 4.32058 6.97721 4.21605C7.26841 4.10405 7.59321 4.04805 7.95161 4.04805C8.31001 4.04805 8.63481 4.10405 8.92601 4.21605C9.21721 4.32058 9.46361 4.46991 9.66521 4.66405C9.87428 4.85071 10.0311 5.07471 10.1356 5.33605C10.2476 5.58991 10.3036 5.86991 10.3036 6.17605C10.3036 6.38511 10.27 6.58298 10.2028 6.76965C10.1356 6.95631 10.0423 7.13551 9.92281 7.30725C9.81081 7.47151 9.68014 7.63205 9.53081 7.78885C9.38148 7.93818 9.22841 8.08005 9.07161 8.21445C8.94468 8.31898 8.84014 8.41978 8.75801 8.51685C8.67588 8.60645 8.60868 8.69605 8.55641 8.78565C8.51161 8.86778 8.47801 8.95365 8.45561 9.04325C8.44068 9.12538 8.43321 9.21498 8.43321 9.31205V9.53605H7.44761V9.20005ZM7.95161 12.112C7.73508 12.112 7.54841 12.0374 7.39161 11.888C7.24228 11.7312 7.16761 11.5446 7.16761 11.328C7.16761 11.104 7.24228 10.9174 7.39161 10.768C7.54841 10.6187 7.73508 10.544 7.95161 10.544C8.16814 10.544 8.35108 10.6187 8.50041 10.768C8.65721 10.9174 8.73561 11.104 8.73561 11.328C8.73561 11.5446 8.65721 11.7312 8.50041 11.888C8.35108 12.0374 8.16814 12.112 7.95161 12.112Z"
									fill="#999999"
								/>
							</svg>
							<span class="b_card__hint-text g-text__p _middle">
								<p
									class="g-text__p _middle"
									v-html="cardData.jsonData.tooltip_max_rate"
								></p>
							</span>
						</span>
					</div>
				</li>
				<li class="b_card__item">
					<div class="b_card__val">
						{{ cardData.apiData.minPV * 100 + '%' }}
					</div>
					<div class="b_card__desc">минимальный первоначальный взнос</div>
				</li>
				<li class="b_card__item">
					<div class="b_card__val">
						{{ cardData.apiData.maxLoanAmt / 1000000 + ' млн ₽' }}
					</div>
					<div class="b_card__desc">
						максимальная сумма кредита
						<div
							v-if="cardData.jsonData?.tooltip_max_loan_amt"
							class="b_card__hint"
						>
							<svg
								class="b_card__hint-icon"
								@mousemove="setCoordsTooltip"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle cx="7.99961" cy="8" r="5.9" stroke="#999999" />
								<path
									d="M7.44761 9.20005C7.44761 9.05818 7.45508 8.92751 7.47001 8.80805C7.49241 8.68111 7.53348 8.55791 7.59321 8.43845C7.66041 8.31151 7.75001 8.18085 7.86201 8.04645C7.98148 7.91205 8.13828 7.76271 8.33241 7.59845C8.64601 7.32965 8.88494 7.08698 9.04921 6.87045C9.21348 6.65391 9.29561 6.42245 9.29561 6.17605C9.29561 5.81765 9.17614 5.52271 8.93721 5.29125C8.69828 5.05978 8.36974 4.94405 7.95161 4.94405C7.53348 4.94405 7.20494 5.05978 6.96601 5.29125C6.72708 5.52271 6.60761 5.81765 6.60761 6.17605H5.59961C5.59961 5.86991 5.65188 5.58991 5.75641 5.33605C5.86841 5.07471 6.02521 4.85071 6.22681 4.66405C6.43588 4.46991 6.68601 4.32058 6.97721 4.21605C7.26841 4.10405 7.59321 4.04805 7.95161 4.04805C8.31001 4.04805 8.63481 4.10405 8.92601 4.21605C9.21721 4.32058 9.46361 4.46991 9.66521 4.66405C9.87428 4.85071 10.0311 5.07471 10.1356 5.33605C10.2476 5.58991 10.3036 5.86991 10.3036 6.17605C10.3036 6.38511 10.27 6.58298 10.2028 6.76965C10.1356 6.95631 10.0423 7.13551 9.92281 7.30725C9.81081 7.47151 9.68014 7.63205 9.53081 7.78885C9.38148 7.93818 9.22841 8.08005 9.07161 8.21445C8.94468 8.31898 8.84014 8.41978 8.75801 8.51685C8.67588 8.60645 8.60868 8.69605 8.55641 8.78565C8.51161 8.86778 8.47801 8.95365 8.45561 9.04325C8.44068 9.12538 8.43321 9.21498 8.43321 9.31205V9.53605H7.44761V9.20005ZM7.95161 12.112C7.73508 12.112 7.54841 12.0374 7.39161 11.888C7.24228 11.7312 7.16761 11.5446 7.16761 11.328C7.16761 11.104 7.24228 10.9174 7.39161 10.768C7.54841 10.6187 7.73508 10.544 7.95161 10.544C8.16814 10.544 8.35108 10.6187 8.50041 10.768C8.65721 10.9174 8.73561 11.104 8.73561 11.328C8.73561 11.5446 8.65721 11.7312 8.50041 11.888C8.35108 12.0374 8.16814 12.112 7.95161 12.112Z"
									fill="#999999"
								/>
							</svg>
							<span class="b_card__hint-text">
								<p
									class="g-text__p _middle"
									v-html="cardData.jsonData.tooltip_max_loan_amt"
								></p>
							</span>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="cardData.links.length > 1" class="b_card__footer">
				<a
					:href="cardData.links[0].href"
					:title="cardData.links[0].text"
					class="b_card__action-button"
				>
					{{ cardData.links[0].text }}
					<div v-if="cardData.links[0].hint" class="b_card__hint">
						<svg
							class="b_card__hint-icon"
							width="100%"
							height="100%"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="8.00156" cy="7.99961" r="5.9" stroke="#fff" />
							<path
								d="M7.44956 9.19985C7.44956 9.05798 7.45703 8.92732 7.47196 8.80785C7.49436 8.68092 7.53543 8.55772 7.59516 8.43825C7.66236 8.31132 7.75196 8.18065 7.86396 8.04625C7.98343 7.91185 8.14023 7.76252 8.33436 7.59825C8.64796 7.32945 8.8869 7.08678 9.05116 6.87025C9.21543 6.65372 9.29756 6.42225 9.29756 6.17585C9.29756 5.81745 9.1781 5.52252 8.93916 5.29105C8.70023 5.05958 8.3717 4.94385 7.95356 4.94385C7.53543 4.94385 7.2069 5.05958 6.96796 5.29105C6.72903 5.52252 6.60956 5.81745 6.60956 6.17585H5.60156C5.60156 5.86972 5.65383 5.58972 5.75836 5.33585C5.87036 5.07452 6.02716 4.85052 6.22876 4.66385C6.43783 4.46972 6.68796 4.32038 6.97916 4.21585C7.27036 4.10385 7.59516 4.04785 7.95356 4.04785C8.31196 4.04785 8.63676 4.10385 8.92796 4.21585C9.21916 4.32038 9.46556 4.46972 9.66716 4.66385C9.87623 4.85052 10.033 5.07452 10.1376 5.33585C10.2496 5.58972 10.3056 5.86972 10.3056 6.17585C10.3056 6.38492 10.272 6.58279 10.2048 6.76945C10.1376 6.95612 10.0442 7.13532 9.92476 7.30705C9.81276 7.47132 9.6821 7.63185 9.53276 7.78865C9.38343 7.93798 9.23036 8.07985 9.07356 8.21425C8.94663 8.31879 8.8421 8.41959 8.75996 8.51665C8.67783 8.60625 8.61063 8.69585 8.55836 8.78545C8.51356 8.86759 8.47996 8.95345 8.45756 9.04305C8.44263 9.12519 8.43516 9.21478 8.43516 9.31185V9.53585H7.44956V9.19985ZM7.95356 12.1119C7.73703 12.1119 7.55036 12.0372 7.39356 11.8879C7.24423 11.7311 7.16956 11.5444 7.16956 11.3279C7.16956 11.1039 7.24423 10.9172 7.39356 10.7679C7.55036 10.6185 7.73703 10.5439 7.95356 10.5439C8.1701 10.5439 8.35303 10.6185 8.50236 10.7679C8.65916 10.9172 8.73756 11.1039 8.73756 11.3279C8.73756 11.5444 8.65916 11.7311 8.50236 11.8879C8.35303 12.0372 8.1701 12.1119 7.95356 12.1119Z"
								fill="#fff"
							/>
						</svg>
						<span
							class="b_card__hint-text g-text__p _middle"
							v-html="cardData.links[0].hint"
						></span>
					</div>
				</a>
				<a
					:href="cardData.links[1].href"
					:title="cardData.links[1].text"
					class="b_card__question-button"
					target="_blank"
				>
					{{ cardData.links[1].text }}
				</a>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	name: 'BCard',
	props: {
		cardData: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	methods: {
		setCoordsTooltip() {
			const tooltip = event.target
				.closest('.b_card__hint')
				.querySelector('.b_card__hint-text')
			let coords = event.target.getBoundingClientRect()
			let right = window.innerWidth - coords.right

			let MARGIN = 100

			if (this.isMobile) {
				MARGIN = 30
			}

			if (right < tooltip.offsetWidth) {
				tooltip.style.left = `${
					event.clientX - MARGIN - tooltip.offsetWidth / 2
				}px`
			} else {
				tooltip.style.left = `${
					event.clientX + MARGIN - tooltip.offsetWidth / 2
				}px`
			}

			tooltip.style.top = `${event.clientY + 20}px`
		},
	},
}
</script>
